import { Vector3 } from "three";

export const convertCoordinates = (vector: Vector3) => {
  return new Vector3(vector.x, vector.z, vector.y * -1);
};
